var React = require('react');

function Dashboard (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 32.816c0-.811.658-1.47 1.47-1.47h19.59c.812 0 1.47.659 1.47 1.47v13.715A1.47 1.47 0 0121.06 48H1.47A1.47 1.47 0 010 46.53V32.817zm2.939 1.47V45.06h16.653V34.286H2.939zM48 46.53A1.47 1.47 0 0146.53 48H26.94a1.47 1.47 0 01-1.47-1.47V21.062c0-.811.658-1.47 1.47-1.47h19.59a1.47 1.47 0 011.469 1.47v25.47zm-2.939-1.469v-22.53H28.408v22.53h16.653zM48 15.184a1.47 1.47 0 01-1.47 1.47H26.94a1.47 1.47 0 01-1.47-1.47V1.469C25.47.658 26.127 0 26.94 0h19.59C47.342 0 48 .658 48 1.47v13.714zm-2.939-1.47V2.94H28.408v10.775h16.653zM0 1.47C0 .657.658 0 1.47 0h19.59c.812 0 1.47.658 1.47 1.47v25.469a1.47 1.47 0 01-1.47 1.47H1.47A1.47 1.47 0 010 26.938V1.469zm2.939 1.469v22.53h16.653V2.94H2.939z"}));
}

Dashboard.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Dashboard;

Dashboard.default = Dashboard;
